import React from 'react'
import css from './style.scss'

export default ({ children }) => (
  <h4 className={css.metricsTitle}>
    {children}
  </h4>
)
